$(document).ready(function(){

	// -- Check id in url --
	checkIdInUrl();

	// -- Smooth Scroll --
	$('a[href^="#"], .scrollTop a').on('click', function(e){
		e.preventDefault();
		var id = $(this).attr("href");
		smoothScroll(id);
	});


	function checkIdInUrl(){
		var url = window.location.href;
		if (url.indexOf('#') >= 0) {
			var id = '#' + url.split('#').pop();
			setTimeout(function(){
				smoothScroll(id);
				if ($(id).is('details')) {
					if ($('html').hasClass('no-details')){
						$(id).addClass('open').attr('open', true);
					} else {
						$(id).attr('open', true);
					}
				}
			},400);
		}
	}

	function smoothScroll(id){
		var headerH = $('.header__navbar').outerHeight();
		$('html, body').animate({
			scrollTop: $(id).offset().top - headerH - 15
		}, 'slow');
		return false;
	}

});